var imageWithTextSlider = new Swiper('.image-with-text-slider-eleven .swiper-container', {
    slidesPerView: 1,
    loop: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
	},
});